<script setup>

const HANGFIRE_URL = process.env.VUE_APP_HANGFIRE_URL;

</script>
<template>
<iframe
    :src="HANGFIRE_URL"
    style="
        width:100%;
        height:100vh;
        border:none;
    "
></iframe>

</template>